/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react"
import { ImmutableObject } from "@hookstate/core";
import { PackageItem, Product } from "../../../hooks/useInventoryState";
import { useShoppingCartItemsState } from "../../../hooks/useShoppingCartItemsState";
import FwFunc from "../../../lib/FwReact/FwFunc";
import { FwNumberDropDown } from "../../../lib/FwReact/FwNumberDropDown";
import { ShoppingCartViewSettings } from "../ShoppingCartControl";
import { ShoppingCartPackageItemAvailability } from "../PackageItemFields/ShoppingCartPackageItemAvailability";
import { useTailwindMediaQueries } from "@/hooks/useTailwindMediaQueries";
//import { ShoppingCartPackageItemImage } from "../PackageItemFields/ShoppingCartPackageItemImage";

//------------------------------------------------------------------------------------
export type ShoppingCartPackageItemOptionalDesktopProps = {
    packageProduct: ImmutableObject<Product>;
    packageItem: ImmutableObject<PackageItem>;
    enableQty: boolean;
    viewSettings: ShoppingCartViewSettings;
}
export const ShoppingCartPackageItemOptionalDesktop: React.FC<ShoppingCartPackageItemOptionalDesktopProps> = props => {
    const mediaQueries = useTailwindMediaQueries();
    const packageProduct = props.packageProduct;
    const isAvailable = (packageProduct.Availability?.TotalIn ?? 0) > 0;
    const canAddToCart = props.enableQty && (isAvailable || props.viewSettings.allowAddingUnavailableItems);
    const item = props.packageItem;
    const shoppingCartItemsState = useShoppingCartItemsState();
    //const showImage = item.Images && (item.Images.length > 0);
    const showAvailability = item.Availability !== undefined;
    const showDailyRate = (mediaQueries.tablet) && (props.viewSettings.hasRates && props.viewSettings.hasDailyRate);
    const showWeeklyRate = (mediaQueries.tablet) && (props.viewSettings.hasRates && props.viewSettings.hasWeeklyRate);
    const showMonthlyRate = (mediaQueries.tablet) && (props.viewSettings.hasRates && props.viewSettings.hasMonthlyRate);


    const handleChangeQtyAsync = async (value: number): Promise<void> => {
        return Promise.resolve().then(() => {
            shoppingCartItemsState.setPackageItemQty(props.packageProduct, props.packageItem, value);
        });
    }
    let maxQty = shoppingCartItemsState.getMaxPackageItemQty(packageProduct, props.packageItem);
    //let maxQty = undefined;
    //if (showAvailability) {
    //    maxQty = (props.packageItem.Availability?.TotalIn || 0) - shoppingCartItemsState.getPackageItemQty(props.packageProduct, props.packageItem);
    //}
    return (
        <tr className="packageitemrow" style={{ /*backgroundColor: item.LineColor*/ }}>
            <td className="col-legend"></td>
            {/*<td className="col-image">*/}
            {/*    {showImage && (*/}
            {/*        <ShoppingCartPackageItemImage product={packageProduct} packageItem={item} />*/}
            {/*    )}*/}
            {/*</td>*/}
            {/*<div className="fld ICode">{item.ICode}</div>*/}
            <td className="col-description">{item.Description}</td>
            {/*<td className="Tags">*/}
            {/*    {item.IsOption && (*/}
            {/*        <Chip label={'optional'} style={{backgroundColor: 'yellow', color: 'black'}}></Chip>*/}
            {/*    )}*/}
            {/*    <Chip label={`x${item.DefaultQuantity}`} style={{ backgroundColor: 'orange', color: 'black' }}></Chip>*/}
            {/*</td>*/}
            {(canAddToCart || showAvailability) && (<>
                <td className="col-qty">
                    {canAddToCart && (
                        <FwNumberDropDown
                            css={css`flex:1 1 0;`}
                            value={shoppingCartItemsState.getPackageItemQty(props.packageProduct, item)}
                            maxQty={maxQty}
                            onChange={(newValue, oldValue) => {
                                handleChangeQtyAsync(newValue);
                            }}
                        />
                        //<div css={css`display:flex;align-items:center;`}>
                        //    {/*<input*/}
                        //    {/*    css={css`width:50px;`}*/}
                        //    {/*    type="text"*/}
                        //    {/*    value={shoppingCartItemsState.getPackageItemQty(props.packageProduct, item)}*/}
                        //    {/*    onChange={e => handleChangeQtyAsync(parseInt(e.currentTarget.value))}*/}
                        //    {/*/>*/}
                        //    {/*<FwNumberBox*/}
                        //    {/*    label={undefined}*/}
                        //    {/*    fwNumberBoxState={qtyState}*/}
                        //    {/*    value={shoppingCartItemsState.getPackageItemQty(props.packageProduct, item)}*/}
                        //    {/*    onChange={handleChangeQtyAsync}*/}
                        //    {/*    backgroundColor={item.IsOption ? 'yellow' : undefined}*/}
                        //    {/*/>*/}


                        //</div>
                    )}
                    {showAvailability && (
                        <ShoppingCartPackageItemAvailability packageItem={item} />
                    )}
                </td>
            </>)}

            {showDailyRate && (
                <td className="col-dailyrate">
                    <span className="CurrencySymbol">{item.CurrencySymbol}</span>
                    <span className="Price">{FwFunc.numberFormatter(item.DailyRate, 2, ',', '.')}</span>
                    {/*<span className="CurrencyCode">{item.CurrencyCode}</span>*/}
                </td>
            )}

            {showWeeklyRate && (
                <td className="col-weeklyrate">
                    <span className="CurrencySymbol">{item.CurrencySymbol}</span>
                    <span className="Price">{FwFunc.numberFormatter(item.WeeklyRate, 2, ',', '.')}</span>
                    {/*<span className="CurrencyCode">{item.CurrencyCode}</span>*/}
                </td>
            )}

            {showMonthlyRate && (
                <td className="col-monthlyrate">
                    <span className="CurrencySymbol">{item.CurrencySymbol}</span>
                    <span className="Price">{FwFunc.numberFormatter(item.MonthlyRate, 2, ',', '.')}</span>
                    {/*<span className="CurrencyCode">{item.CurrencyCode}</span>*/}
                </td>
            )}

            {false && showAvailability && (
                <td className="col-availability">
                    <ShoppingCartPackageItemAvailability packageItem={item} />
                </td>
            )}
        </tr>
    );
}